/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { IpApp } from '@tmna-ct/ipapps-core-js';
import styles from './styles';

const WindowServices = ({ t, classes }) => {
  const { container, separation } = classes;
  return (
    <div className={container}>
      <h3 className={separation}>{t('screens.windowOpenClose.title2')}</h3>
      <p className={separation}>{t('screens.windowOpenClose.description9')}</p>
      <a className={separation} href={IpApp.open('com.toyota.ipapps.audio.test-suite')}>Open Test Suite</a>
      <a className={separation} href={IpApp.open('com.toyota.ipapps.info.amazon-music')}>Open Amazon Music</a>
      <a className={separation} href={IpApp.open('com.toyota.ipapps.info.link-assist')}>Open Link Assist</a>
      <h3 className={separation}>{t('screens.windowOpenClose.title')}</h3>
      <p className={separation}>{t('screens.windowOpenClose.description2')}</p>
      <Button variant="contained" className={separation} onClick={() => IpApp.close()}>
        {t('screens.windowOpenClose.closeNoAnimation')}
      </Button>
      <p className={separation}>{t('screens.windowOpenClose.description3')}</p>
      <Button variant="contained" className={separation} onClick={() => IpApp.close('ClosingAnimation')}>
        {t('screens.windowOpenClose.closeWithCloseAnim')}
      </Button>
      <p className={separation}>{t('screens.windowOpenClose.description4')}</p>
      <Button variant="contained" className={separation} onClick={() => IpApp.close('OpeningAnimation')}>
        {t('screens.windowOpenClose.closeWithOpenAnim')}
      </Button>
      <p className={separation}>{t('screens.windowOpenClose.description5')}</p>
      <Button variant="contained" className={separation} onClick={() => IpApp.hide()}>
        {t('screens.windowOpenClose.hideNoAnimation')}
      </Button>
      <p className={separation}>{t('screens.windowOpenClose.description6')}</p>
      <Button variant="contained" className={separation} onClick={() => IpApp.hide('ClosingAnimation')}>
        {t('screens.windowOpenClose.hideWithCloseAnim')}
      </Button>
      <p className={separation}>{t('screens.windowOpenClose.description7')}</p>
      <Button variant="contained" className={separation} onClick={() => IpApp.hide('OpeningAnimation')}>
        {t('screens.windowOpenClose.hideWithOpenAnim')}
      </Button>
      <p className={separation}>{t('screens.windowOpenClose.description8')}</p>
      <Button variant="contained" className={separation} onClick={() => IpApp.crash('Test error message')}>
        {t('screens.windowOpenClose.error')}
      </Button>
    </div>
  );
};

WindowServices.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(WindowServices));
